<small style="position: fixed" class="debug">{{me}}</small>
<div>
  <div class="cardInner">
    <br/>
    <div>
      @if (dynamicsInitialized) {
        <div class="noScroll">
          @if (bindSceneMode) {
            <div fxFlex="column" class="bar">
              <button class="icon-button buttonBarButt addPositionEvent exit-icon" mat-button (click)="openSceneAssignmentDialog();">
                <mat-icon>add_circle_outline</mat-icon>
              </button>
              <button class="icon-button buttonBarButt deletePosition exit-icon" mat-button (click)="onClearInput();">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          }
          <dynamic-form [fields]="uiConfigInit" class="noScroll" (submit)="submit($event)">
          </dynamic-form>
          <div class="assigned">
            @if (assignedType === 'SCENE') {
              <mat-icon>control_camera</mat-icon>
            }
            @if (assignedType === 'RESOURCE') {
              <mat-icon>collections</mat-icon>
            }
            <mat-label>{{assignedName}}</mat-label>
          </div>
        </div>
      }
    </div>
  </div>
  <br/>
  <br/>
  <br/>
</div>

<!--        <mat-form-field>-->
<!--            <input matInput [disabled]="readOnly" class="rateInput" [(ngModel)]="m_clickEventParam" (change)="dispatchEventsAll()">-->
<!--        </mat-form-field>-->
<!--        <button class="icon-button buttonBarButt" mat-button (click)="openSceneRemove();">-->
<!--            <mat-icon>remove</mat-icon>-->
<!--        </button>-->
